import { io } from "socket.io-client";
import { baseUrl } from "stores";

export const socket = io(baseUrl, {
    autoConnect: false, // Kita set false agar koneksi diatur secara manual (misal setelah user login)
});
